"use client";

import React from "react";
import OurTeam from "../components/OurTeam/OurTeam";
import RotatedBlocks from "../components/RotatedBlocks/RotatedBlocks";
import RichText from "../components/RichText/richText";
import { ContactUsForm } from "../components/ContactUs/ContactUsForm";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

export default function AboutPage() {
  return (
    <div className="flex flex-col gap-[100px] my-[35px]">
      <FirstBlockAbout
        tags={["Mission", "Values", "Team"]}
        title="Who is Enjoyable design inc."
        buttonText="View All Works"
        buttonLink="/about/portfolio"
        media={{
          type: "image",
          src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FAbout%20Us%2FaboutusBackground.webp?alt=media&token=af4af148-8f1a-487a-875e-a285835636a9",
        }}
        highlightWords={["Enjoyable", "design", "inc."]}
      />
      <div id="mission">
        <RichText
          Title="Our Mission"
          RegularText="At Enjoyable Design Inc., we are your One-Stop Digital Solution. As a full-service branding and digital marketing agency, we combine creativity and technical precision to deliver exceptional results that are as effective as they are enjoyable. From concept to execution, our comprehensive suite of services is designed to meet your needs and exceed your expectations—all at competitive prices.<br><br>
With a passion for the internet and the boundless opportunities of the digital world, our team is dedicated to opening these doors for you. Whether you're building your online presence or scaling for the future, we tailor each project to ensure scalability and long-term success. Your reputation is our priority, and we treat your goals with the same dedication and high standards we bring to our own ventures and startups."
        />
      </div>
      <RotatedBlocks />
      {/* <OurTeam /> */}
      <ContactUsForm />
    </div>
  );
}
